import * as React from 'react'
import Img from 'components/common/Img'
import HTag from 'components/common/HTag'
import { FaLinkedin } from 'react-icons/fa'

export default function LinkedinCTA({
	heading,
	description,
	url,
	bgImage,
	images,
}) {
	return (
		<section className="relative bg-suede-black text-center text-white">
			<Img
				className="pointer-events-none !absolute inset-0 size-full opacity-20 grayscale"
				image={bgImage}
				objectFit="cover"
				alt={heading?.text}
			/>

			<header className="relative">
				<div className="richtext mx-auto max-w-screen-md px-4 py-12">
					<HTag className="h3 technical-lg" {...heading} />
					<div>
						<p>
							<a
								className="inline-block"
								href={url}
								aria-label="LinkedIn"
								target="_blank"
								rel="noopener noreferrer"
							>
								<FaLinkedin className="mx-auto text-4xl" />
							</a>
						</p>
						<p>{description}</p>
					</div>
				</div>
			</header>

			<figure className="pointer-events-none mt-[-1px] flex">
				{images.map((image) => (
					<Img
						className="block aspect-[2.2] object-cover <md:aspect-[.9]"
						image={image}
						key={image._key}
					/>
				))}
			</figure>
		</section>
	)
}
